import React from "react";
import { useTable, useExpanded, usePagination, useSortBy } from "react-table";
import { useTranslation } from "react-i18next";
import InnerTable from "../InnerTable/InnerTable";
import ErrorRender from "../ErrorRender/ErrorRender";
import arrowDownIcon from "../../assets/images/arrow-down.png";
import arrowUpIcon from "../../assets/images/arrow-up.png";
import { makeDepositData, makeInnerDepositData } from "./makeData";
import MobileInnerTable from "../MobileInnerTable/MobileInnerTable";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import "./Table.scss";
import "../../assets/scss/variables.scss";
import {NamList} from "../../utils/helpers/table";


function Table({ columns: userColumns, data, renderRowSubComponent }) {
  const { t } = useTranslation("common");
  const colsWithSort = [
    t("depositsInnerTable.gemel"),
    t("depositsInnerTable.depositDate"),
    t("depositsInnerTable.monthSalary")
  ];
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    visibleColumns,
    page,
    gotoPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    state: { pageIndex },
    // state: { expanded },
  } = useTable(
    {
      columns: userColumns,
      data,
      initialState: { pageIndex: 0 },
      disableSortRemove: true,
      //autoResetExpanded: true,
    },
    useSortBy,
    useExpanded, // Use the useExpanded plugin hook
    usePagination
  );

//console.log(pageOptions)

  return (
    <div className="table-expanded-wrapper">
      <table {...getTableProps()} role>
        <thead id="main-table-header">
          {headerGroups.slice(1).map((headerGroup, index) => {
            // slice remove the first header (fake row)
            return (
              <tr {...headerGroup.getHeaderGroupProps()} role>
                {headerGroup.headers.map((column) => {
                  return (
                    !column.hideHeader && (
                      <th 
                        key={index}
                        {...column.getHeaderProps(
                          colsWithSort.includes(column.Header) &&
                            column.getSortByToggleProps({ title: "מיין לפי שם שדה למיון" })
                        )}
                        role
                      >
                        {column.render("Header")}
                        <span>
                          {
                            colsWithSort.includes(column.Header) && setColIsSorted(column)
                          }
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <ArrowDropDownIcon />
                            ) : (
                              <ArrowDropUpIcon />
                            )
                          ) : (
                            ""
                          )}
                        </span>
                      </th>
                    )
                  );
                })}
              </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()} role>
          {page.map((row , index) => {
            prepareRow(row);
            const rowProps = row.getRowProps();

            return (
              // Use a React.Fragment here so the table markup is still valid
              <React.Fragment key={rowProps.key}>
                <tr {...rowProps} {...row.getToggleRowExpandedProps()} role>
                  {row.cells.map((cell) =>
                    row.isExpanded ? (
                      <td
                      key={index}
                      tabIndex="-1"
                        style={{ background: "#F0F3F6" }}
                        {...cell.getCellProps()}
                        role
                      >
                        {cell.render("Cell")}
                      </td>
                    ) : (
                      // fix's extra row when row is expanded bug
                      row.values[Object.keys(row.values)[0]] && (
                        <td key={index} tabIndex="-1" {...cell.getCellProps()} role>{cell.render("Cell")}</td>
                      )
                    )
                  )}
                </tr>
                {/*
                    If the row is in an expanded state, render a row with a
                    column that fills the entire length of the table.
                  */}
                {row.isExpanded ? (
                  <tr style={{ background: "#F0F3F6" }}>
                    <td key={index} tabIndex="-1" colSpan={visibleColumns.length}>
                      {/*
                          Inside it, call our renderRowSubComponent function. In reality,
                          you could pass whatever you want as props to
                          a component like this, including the entire
                          table instance. But for this example, we'll just
                          pass the row
                        */}
                      {renderRowSubComponent({ row })}
                    </td>
                  </tr>
                ) : null}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      {pageOptions.length !== 1 ?
      <div className="pagination">
        <button
          type="button"
          onClick={() => nextPage()}
          disabled={!canNextPage}
          style={{ border: 0, backgroundColor: "transparent" }}
          aria-label="Next page"
        >
          <ArrowForwardIosOutlinedIcon
            sx={{
              marginLeft: "10px",
              cursor: "pointer",
              "&:hover": {
                color: "$Logo-L400",
              },
            }}
          />
        </button>       
            {/*{t("general.page")}{" "} {pageIndex + 1} {t("general.from")} {pageOptions.length} */}
            <li>{NamList(pageIndex , pageOptions ,gotoPage)}</li>  
        <button
          type="button"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
          style={{ border: 0, backgroundColor: "transparent" }}
          aria-label="Previous page"
        >
          <ArrowBackIosOutlinedIcon
            sx={{
              marginLeft: "10px",
              cursor: "pointer",
              "&:hover": {
                color: "$Logo-L400",
              },
            }}
          />
        </button>
      </div>
      : null}
    </div>
  );
}

function setColIsSorted(column) {
  column.isSorted = true;
}

function TableExpanded({ tableData, mobileRender,funds }) {
  const { t } = useTranslation("common");
    const [fundsData , setFunds] = React.useState(funds)
  const columns = React.useMemo(
    () => [
      {
        Header: "1",
        hideHeader: true,
        columns: !mobileRender
          ? [
              {        
                Header: t("deposits.gemel"),
                accessor: "kopatGemel",
                sortDescFirst: true,                   
              },
              {
                Header: t("deposits.employerName"),
                accessor: "employerName",
                sortDescFirst: true,
              },
              {
                Header: t("deposits.depositDate"),
                accessor: "depositDate",
                disableFilters: true,
                sortDescFirst: true,
                sortType: (a, b) => {
                  if (
                    new Date(a.values.depositDate).valueOf() >
                    new Date(b.values.depositDate).valueOf()
                  )
                    return 1;

                  if (
                    new Date(b.values.depositDate).valueOf() >
                    new Date(a.values.depositDate).valueOf()
                  )
                    return -1;

                  return 0;
                },
              },
              {
                Header: t("deposits.monthSalary"),
                accessor: "salaryMonth",
                disableFilters: true,
                sortDescFirst: true,
                sortType: (a, b) => {
                  if (
                    new Date(`01/${a.values.depositDate}`).valueOf() >
                    new Date(`01/${b.values.depositDate}`).valueOf()
                  )
                    return 1;

                  if (
                    new Date(`01/${b.values.depositDate}`).valueOf() >
                    new Date(`01/${a.values.depositDate}`).valueOf()
                  )
                    return -1;

                  return 0;
                },
              },
              {
                Header: t("deposits.depositSum") + " ₪",
                accessor: "sum",
              },
              {
                Header: t("deposits.absorptionReport"),
                accessor: "status",
              },
            ]
          : [
              {
                Header:  t("deposits.monthSalary"),
                accessor: "salaryMonth",
                disableFilters: true,
                sortDescFirst: true,
                sortType: (a, b) => {
                  if (
                    new Date(`01/${a.values.depositDate}`).valueOf() >
                    new Date(`01/${b.values.depositDate}`).valueOf()
                  )
                    return 1;

                  if (
                    new Date(`01/${b.values.depositDate}`).valueOf() >
                    new Date(`01/${a.values.depositDate}`).valueOf()
                  )
                    return -1;

                  return 0;
                },
              },
              {
                Header: t("deposits.depositSum") + " ₪",
                accessor: "sum",
              },
              {
                Header: t("deposits.employerName"),
                accessor: "employerName",
              },
              {
                Header: t("deposits.absorptionReport"),
                accessor: "status",
              },
            ],
      },
      {
        // Build our expander column
        // Header: () => null,
        id: "expander", // Make sure it has an ID

        Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
          <span /*{...getToggleAllRowsExpandedProps()}*/>
            {/* {isAllRowsExpanded ? '👇' : '👉'} */}
            {!mobileRender ? t("deposits.moreDetails") : ""}
          </span>
        ),
        Cell: ({ row }) =>
          // Use the row.canExpand and row.getToggleRowExpandedProps prop getter
          // to build the toggle for expanding a row
          row.canExpand ? (
            <span
              // {...row.getToggleRowExpandedProps({
              //    title: t("deposits.moreDetails"), 
              //   style: {
              //     // We can even use the row.depth property
              //     // and paddingLeft to indicate the depth
              //     // of the row
              //     paddingLeft: `${row.depth * 2}rem`,
              //   },
              // })}
            >
              <button
                style={{
                  cursor: "pointer",
                  backgroundColor: "transparent",
                  border: 0,
                }}
                id={`btn-Expande-${row?.original?.id}`}
                aria-expanded={row.isExpanded ? row.isExpanded  : false}
                aria-controls={row?.original?.id}
                aria-label={t("arialabel.btntabel")}
              >
              {row.isExpanded ? (
                  <img src={arrowUpIcon} alt="" />
              ) : (

                  <img src={arrowDownIcon} alt="" />
              )}
                </button>
            </span>
          ) : null,
      },
    ],
    // eslint-disable-next-line
    []
  );

  const renderRowSubComponent = React.useCallback(
    ({ row }) =>
      !mobileRender ? (
        <div className="deposits-inner-table">
          {!row.values["status"].props.isDepositOk && <ErrorRender />}
          <InnerTable
            data={makeInnerDepositData(tableData[row?.original?.id])}
          />
        </div>
      ) : (
        <div className="deposits-inner-table">
          {!row.values["status"].props.isDepositOk && <ErrorRender />}
          <MobileInnerTable
            depositData={makeInnerDepositData(
              tableData[row?.original?.id],
              true
            )}
          />
        </div>
      ),
    // eslint-disable-next-line
    [tableData]
  );

  const data = React.useMemo(() => makeDepositData(tableData,funds), [tableData]);

  return (
    <>
      <Table
        columns={columns}
        data={data}
        renderRowSubComponent={renderRowSubComponent}
      />
    </>
  );
}

export default TableExpanded;
